import React from 'react';
import {
  MemoryRouter as Router,
  // BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';

import Template from '../template';

/**
 * Import pages with paths
 */
import HOC from '../pages/HOC';

import {
  WGW,
  News,
  Calendar,
  HomePage,
  Reminder,
  ZoneSetup,
  Education,
  GeneralPage,
  DownloadPDF,
  HelpScreens,
  MaterialList,
  DepoEventList,
  ExportCalendar,
  MaterialDetails,
  DepoEventDetails,
  CollectionRequirements,
} from '../pages';
import Campaign from '../pages/Campaign';
import NewsDetails from '../pages/News/components';
import { MoreLocationsList } from '../pages/DepoEvent/DepoEventList/components';
import { SingleReminder, WeeklyReminder } from '../pages/Reminder/sections';

import {
  FormPage,
  TimeCheck,
  ContactUs,
  ReviewSticker,
  OtherProblems,
  DescriptionPage,
  ConfirmLocation,
  DamagedCartPage,
  MissedCollections,
  NotScheduledForToday,
  MissedCollectionSubmission,
} from '../pages/HelpScreens/sections';

/**
 * Multi district screen
 */
import {
  ConfirmZone, MultiDistrict, ZoneSetupList, ZoneSetupMap, ZoneSetupSearch
} from '../pages/ZoneSetupScreens/components';
import Feedback from '../pages/HelpScreens/sections/DamagedCart/Feedback';

/**
 * Public route constants
 */
const routeConst = {
  home: '/',
  wgw: '/wgw',
  news: '/news',
  help: '/help',
  calendar: '/cal',
  reminder: '/reminder',
  resources: '/resources',
  education: '/education',
  zoneSetup: '/zone-setup',
  MaterialList: '/material-list',
  reportProblem: '/report-problem',
  selectDistricts: '/select-districts',
  campaign: '/campaign'
};

const Enhanced = {
  WGW: HOC(WGW),
  News: HOC(News),
  Calendar: HOC(Calendar),
  HomePage: HOC(HomePage),
  Education: HOC(Education),
  ZoneSetup: HOC(ZoneSetup),
  HelpScreens: HOC(HelpScreens),
  NewsDetails: HOC(NewsDetails),
  GeneralPage: HOC(GeneralPage),
  DownloadPDF: HOC(DownloadPDF),
  MaterialList: HOC(MaterialList),
  ZoneSetupMap: HOC(ZoneSetupMap),
  ZoneSetupList: HOC(ZoneSetupList),
  DepoEventList: HOC(DepoEventList),
  ExportCalendar: HOC(ExportCalendar),
  ZoneSetupSearch: HOC(ZoneSetupSearch),
  MaterialDetails: HOC(MaterialDetails),
  DepoEventDetails: HOC(DepoEventDetails),
  MoreLocationsList: HOC(MoreLocationsList),
  CollectionRequirements: HOC(CollectionRequirements),
  Campaign: HOC(Campaign)
};

/**
 * Root Router
 */
const Routes = ({ pluginId }) => {
  const {
    wgw,
    home,
    news,
    help,
    calendar,
    education,
    reminder,
    zoneSetup,
    materialList,
    selectDistricts,
    campaign
  } = routeConst;

  return (
    <Router>
      <Template pluginId={pluginId}>
        <Switch>
          <Route
            path={home}
            key={() => Math.random()}
            exact
            render={() => <Enhanced.HomePage />}
          />
          <Route
            path={selectDistricts}
            exact
            render={() => <MultiDistrict />}
          />
          <Route
            path={help}
            render={({ match: { url } }) => (
              <>
                <Route path={`${url}/`} component={Enhanced.HelpScreens} exact />
                <Route path={`${url}/form-page`} component={FormPage} />
                <Route path={`${url}/feedback`} component={Feedback} />
                <Route path={`${url}/damaged-cart/:oidx`} component={DamagedCartPage} />
                <Route path={`${url}/time-check`} component={TimeCheck} />
                <Route path={`${url}/contact-us`} component={ContactUs} />
                <Route path={`${url}/other-problems`} component={OtherProblems} />
                <Route path={`${url}/confirm-location`} component={ConfirmLocation} />
                <Route path={`${url}/description-page`} component={DescriptionPage} />
                <Route path={`${url}/missed-collections`} component={MissedCollections} />
                <Route path={`${url}/not-scheduled-for-today`} component={NotScheduledForToday} />
                <Route path={`${url}/missed-collection-submission/review-sticker`} component={ReviewSticker} />
                <Route path={`${url}/missed-collection-submission`} component={MissedCollectionSubmission} exact />
              </>
            )}
          />
          <Route
            path={wgw}
            render={({ match: { url } }) => (
              <>
                <Route path={`${url}/`} component={Enhanced.WGW} exact />
                <Route path={`${url}/general-page`} component={Enhanced.GeneralPage} />
                <Route path={`${url}/depo-list`} component={Enhanced.DepoEventList} exact />
                <Route path={`${url}/event-list`} component={Enhanced.DepoEventList} exact />
                <Route path={`${url}/depo-details`} component={Enhanced.DepoEventDetails} />
                <Route path={`${url}/event-details`} component={Enhanced.DepoEventDetails} />
                <Route path={`${url}/material-details`} component={Enhanced.MaterialDetails} />
                <Route path={`${url}/depo-list/locations`} component={Enhanced.MoreLocationsList} />
                <Route path={`${url}/event-list/locations`} component={Enhanced.MoreLocationsList} />
                <Route path={`${url}/collection-requirements`} component={Enhanced.CollectionRequirements} />
              </>
            )}
          />
          <Route
            path={calendar}
            render={({ match: { url } }) => (
              <>
                <Route path={`${url}/`} component={Enhanced.Calendar} exact />
                <Route path={`${url}/reminder`} exact component={Reminder} />
                <Route path={`${url}/reminder/single`} component={SingleReminder} />
                <Route path={`${url}/reminder/weekly`} component={WeeklyReminder} />
                <Route path={`${url}/download-pdf`} component={Enhanced.DownloadPDF} />
                <Route path={`${url}/export-calendar`} component={Enhanced.ExportCalendar} />
                <Route path={`${url}/depo-list`} component={Enhanced.DepoEventList} />
                <Route path={`${url}/event-list`} component={Enhanced.DepoEventList} />
                <Route path={`${url}/general-page`} component={Enhanced.GeneralPage} />
                <Route path={`${url}/depo-list/locations`} component={MoreLocationsList} />
                <Route path={`${url}/depo-details`} component={Enhanced.DepoEventDetails} />
                <Route path={`${url}/event-list/locations`} component={MoreLocationsList} />
                <Route path={`${url}/event-details`} component={Enhanced.DepoEventDetails} />
                <Route path={`${url}/collection-requirements`} component={Enhanced.CollectionRequirements} />
              </>
            )}
          />
          <Route
            path={zoneSetup}
            render={({ match: { url } }) => (
              <>
                <Route path={`${url}/`} component={Enhanced.ZoneSetup} exact />
                <Route path={`${url}/confirm-zone`} component={ConfirmZone} />
                <Route path={`${url}/map`} component={Enhanced.ZoneSetupMap} />
                <Route path={`${url}/list`} component={Enhanced.ZoneSetupList} />
                <Route path={`${url}/search`} component={Enhanced.ZoneSetupSearch} />
              </>
            )}
          />
          <Route
            path={education}
            render={() => <Enhanced.Education />}
          />
          <Route
            path={reminder}
            render={() => <Enhanced.Reminder />}
          />
          <Route
            path={news}
            render={({ match: { url } }) => (
              <>
                <Route path={`${url}/`} exact component={Enhanced.News} />
                <Route path={`${url}/:topicId`} component={Enhanced.NewsDetails} />
              </>
            )}
          />
          <Route
            path={campaign}
            render={() => <Enhanced.Campaign />}
          />
          <Route
            path={materialList}
            render={() => <Enhanced.MaterialList />}
          />

        </Switch>
      </Template>
    </Router>
  );
};

export default Routes;
